import { MapPin } from "lucide-react";

const AREAS = ["Las Vegas", "Henderson", "Enterprise", "Spring Valley", "Summerlin", "Southern Highlands", "Mountains Edge", "Southwest Las Vegas"];

export const ServiceAreaSection = () => (
  <section className="py-24 sm:py-28 border-b border-zinc-800/60" data-testid="service-area-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-start">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Where We Work</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-white mt-4 mb-6">
            Mobile Mechanic Serving the Las Vegas Valley
          </h2>
          <p className="text-zinc-400 leading-relaxed mb-4">
            Mason's Mobile travels to customers throughout Las Vegas, Henderson and the
            surrounding communities. Whether your car won't start in your driveway in
            Summerlin, you need brake repair at your office in Spring Valley, or you'd
            like a pre-purchase inspection before buying a used car in Henderson — we
            bring the shop to you.
          </p>
          <p className="text-zinc-400 leading-relaxed">
            No towing, no shuttle rides, no waiting rooms. One call and a certified
            mobile mechanic comes to your home, workplace or wherever your vehicle sits.
          </p>
        </div>
        <div>
          <h3 className="font-heading text-lg font-semibold text-white mb-5">Areas We Serve</h3>
          <div className="grid grid-cols-2 gap-3">
            {AREAS.map((a) => (
              <div key={a} className="flex items-center gap-2.5 bg-[#121212] border border-zinc-800 rounded-sm px-4 py-3">
                <MapPin className="h-4 w-4 text-blue-500 shrink-0" />
                <span className="text-zinc-300 text-sm">{a}</span>
              </div>
            ))}
          </div>
          <p className="text-zinc-600 text-xs mt-4">Outside these areas? Call us — we cover most of the Las Vegas Valley.</p>
        </div>
      </div>
    </div>
  </section>
);
